import { render } from "./HotPointCard.vue?vue&type=template&id=1ceb0298&scoped=true"
import script from "./HotPointCard.vue?vue&type=script&lang=js"
export * from "./HotPointCard.vue?vue&type=script&lang=js"

import "./HotPointCard.vue?vue&type=style&index=0&id=1ceb0298&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ceb0298"]])

export default __exports__